"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const music_visualization_1 = require("./music-visualization");
const types_1 = require("./types");
class Coordinates extends music_visualization_1.MusicVisualization {
    constructor(element, onClick) {
        super(element, { top: 0, bottom: 12, left: 35, right: 0 }, true, true, false, onClick);
    }
    updateDataRepresentation() {
        this.addNodeShapes(types_1.Circle);
        this.addNodeLabels();
        this.addEdgeLines();
    }
    ;
}
exports.Coordinates = Coordinates;



//////////////////
// WEBPACK FOOTER
// ./~/music-visualization/lib/coordinates.js
// module id = 1744
// module chunks = 3